"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AgreementLayout = require("./AgreementLayout");
Object.keys(_AgreementLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AgreementLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AgreementLayout[key];
    }
  });
});